/* ============================================================
   ErgoObject - Sortieroptionen von Boost PFS reduzieren
   12.09.2026 - Protokoll 034

   Boost baut die Sortierliste aus
   boostPFSConfig.settings.general.customSortingList
   (kommt aus dem Shop-Metafeld bc-sf-filter.settings, gepflegt
   vom Boost-Dashboard). Voreingestellt war dort:
   relevance|best-selling|manual|title-ascending|title-descending|
   price-ascending|price-descending|created-ascending|created-descending

   Raus auf Kategorieseiten:
   - "relevance" (Suchrelevanz) hat ohne Suchbegriff keine Aussage
   - "manual" (im Deutschen als "Handbuch" fehluebersetzt) ist bei
     regelbasierten Collections ohne Funktion
   - "created-ascending" (aelteste zuerst) braucht im Shop niemand

   Eingebunden in snippets/boost-pfs.liquid, laeuft nach
   boost-pfs-filter.js und vor boost-pfs-init.js.

   Sollte der Kunde die Liste spaeter im Boost-Dashboard pflegen
   wollen, muss diese Datei wieder raus - sonst ueberschreibt sie
   die Einstellung aus dem Dashboard.
   ============================================================ */
(function () {
  var COLLECTION = 'best-selling|price-ascending|price-descending|title-ascending|title-descending|created-descending';
  var SEARCH = 'relevance|' + COLLECTION;

  var tpl = '';
  try {
    tpl = (boostPFSAppConfig.general.template || '') + '';
  } catch (e) {}
  var value = tpl.indexOf('search') !== -1 ? SEARCH : COLLECTION;

  try {
    if (boostPFSConfig && boostPFSConfig.settings && boostPFSConfig.settings.general) {
      boostPFSConfig.settings.general.customSortingList = value;
    }
  } catch (e) {}

  try {
    if (boostPFSAppConfig && boostPFSAppConfig.settings && boostPFSAppConfig.settings.general) {
      boostPFSAppConfig.settings.general.customSortingList = value;
    }
  } catch (e) {}

  try {
    if (typeof boostPFSFilterConfig !== 'undefined') {
      if (!boostPFSFilterConfig.general) boostPFSFilterConfig.general = {};
      boostPFSFilterConfig.general.customSortingList = value;
    }
  } catch (e) {}
})();
